module.exports = __webpack_public_path__ + "img/logo.c9a9688a.png";